import { forwardRef } from 'react';
import type { ReactElement, ForwardedRef } from 'react';

import { withI18n } from '../../services/i18n';

import type { I18n } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/types';

type BookOnWebsiteProps = {
  i18n: I18n;
  className?: string;
};

const BookOnWebsite = (
  { className = undefined, i18n }: BookOnWebsiteProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => (
  <div className={className} ref={ref}>
    {i18n.translate('book_on_hotelSite_label')}
  </div>
);

export default withI18n(forwardRef(BookOnWebsite));
